import React from 'react';
import {Box, Container, Typography} from '@mui/material';

export function Footer() {
    return (
        <Box component="footer" sx={{
            borderTop: '1px solid rgba(0,0,0,0.06)',
            mt: 6, py: 3,
            background: 'transparent',
        }}>
            <Container maxWidth="lg">
                <Typography variant="body2" sx={{ textAlign: 'center', color: 'text.secondary', fontSize: '0.8rem' }}>
                    assetsMaven.com — alfaPivot, LLC © {new Date().getFullYear()}
                </Typography>
            </Container>
        </Box>
    );
}
